import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e0a6463"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aspects__content" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_AspectComponent = _resolveComponent("AspectComponent")!
  const _component_Card = _resolveComponent("Card")!
  const _component_EditAspect = _resolveComponent("EditAspect")!
  const _component_ModalWindow = _resolveComponent("ModalWindow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Card, {
      title: _ctx.$t('aspects'),
      class: "aspects"
    }, {
      buttons: _withCtx(() => [
        _createVNode(_component_IconButton, {
          hint: _ctx.$t('add-new-aspect'),
          type: "PlusIcon",
          variant: "transparent",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modal = true))
        }, null, 8, ["hint"])
      ]),
      content: _withCtx(() => [
        _createElementVNode("ul", _hoisted_1, [
          (!_ctx.characters[_ctx.current].aspects.length)
            ? (_openBlock(), _createElementBlock("li", _hoisted_2, _toDisplayString(_ctx.$t("click-plus-to-add-aspect")), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.characters[_ctx.current].aspects, (aspect, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: _ctx.characters[_ctx.current].name + index + aspect.title
            }, [
              _createVNode(_component_AspectComponent, {
                aspect: aspect,
                onRemove: ($event: any) => (_ctx.remove(index)),
                onUpdate: (newAspect) => _ctx.update(newAspect, index)
              }, null, 8, ["aspect", "onRemove", "onUpdate"])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_ModalWindow, {
      modelValue: _ctx.modal,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modal) = $event)),
      title: _ctx.$t('create-new-aspect')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_EditAspect, {
          mode: "new",
          aspect: { title: '', description: '', type: _ctx.AspectType.Neutral },
          onUpdate: _cache[1] || (_cache[1] = (newAspect) => _ctx.add(newAspect)),
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modal = false))
        }, null, 8, ["aspect"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}